import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './components/Home'
import Navigation from './components/Navigation'
import About from './components/About'
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop'
import Bowls from './components/Bowls'
import Cups from './components/Cups'
import Plates from './components/Plates'
import Decor from './components/Decor'
import Vases from './components/Vases'
import Teapots from './components/Teapots'
// import Videos from './components/Videos'
import Other from './components/Other'

function App() {
  return (
    <Router>
      <ScrollToTop>
        <div className="App">
          <Navigation />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/works" element={<Decor />} />
              <Route path="/works/bowls" element={<Bowls />} />
              <Route path="/works/cups" element={<Cups />} />
              <Route path="/works/plates" element={<Plates />} />
              <Route path="/works/decor" element={<Decor />} />
              <Route path="/works/vases" element={<Vases />} />
              <Route path="/works/teapots" element={<Teapots />} />
              {/* <Route path="/works/videos" element={<Videos />} /> */}
              <Route path="/works/bts" element={<Other />} />
            </Routes>
          <Contact />
        </div>
      </ScrollToTop>
    </Router>
  );
}

export default App;
